import { render, staticRenderFns } from "./SearchCompany.vue?vue&type=template&id=35940f26"
import script from "./SearchCompany.vue?vue&type=script&lang=js"
export * from "./SearchCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports